import { FC } from 'react';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import { Avatar, Box, Text, TextProps } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials-standalone';
import s from './CreatorInfo.module.scss';

interface Props {
  className?: string;
  textSize?: TextProps['size'];
  hasUnderline?: boolean;
}

const CreatorInfo: FC<Props> = ({
  textSize = 'medium',
  className,
  hasUnderline = false,
}) => {
  const {
    template: {
      partnerProfileDetails: { profileImage, businessName },
    },
  } = useTemplateContext();

  return (
    <Box gap="12px" className={className}>
      <Avatar
        size={textSize === 'small' ? 'size30' : 'size24'}
        imgProps={{ src: profileImage, className: s.avatar, alt: businessName }}
      />
      <Box className={s.textContainer}>
        <Trans
          i18nKey="marketplace.templates-page.hero-section.created-by"
          values={{
            businessName,
          }}
        >
          <Text size={textSize} secondary>
            Created by&nbsp;
            <Text
              secondary
              size={textSize}
              weight="bold"
              className={hasUnderline ? s.underline : ''}
            >
              Creator
            </Text>
          </Text>
        </Trans>
      </Box>
    </Box>
  );
};

export default CreatorInfo;
